import EventTypes from "../../../shared/EventTypes";
import AbstractAction from "../AbstractAction";

export default class UpdateLayerAction extends AbstractAction {
    constructor(provider, elements, layer) {
        super(provider);

        this._elements = Array.isArray(elements) ? elements : [elements];
        this.oldLayers = this._elements.map(el => el.layer);
        this.newLayer = layer;
    }

    finish() {
        this.redo();
        super.finish();
    }

    undo() {
        this._elements.forEach((el, i) => {
            this.newLayer?.removeElement(el);
            this.oldLayers[i]?.addElement(el);
            el.layer = this.oldLayers[i];
        });
        this.emit(EventTypes.UPDATE_ELEMENT_LAYER, this._elements, this.oldLayers[0]?.id);
    }

    redo() {
        this._elements.forEach((el, i) => {
            this.oldLayers[i]?.removeElement(el);
            this.newLayer?.addElement(el);
            el.layer = this.newLayer;
        });
        this.emit(EventTypes.UPDATE_ELEMENT_LAYER, this._elements, this.newLayer?.id);
    }
}
